var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "dashboardContents",
    staticClass: "dashboard-contents"
  }, [_c('div', {
    ref: "dashboardTit",
    staticClass: "dashboard-tit border-bottom py-20 min-h-120px d-flex align-center"
  }, [_c('v-container', {
    staticClass: "container--x-large"
  }, [_vm.$scopedSlots['tit'] ? [_vm._t("tit")] : [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " "), _vm.$scopedSlots['titBtn'] ? [_vm._t("titBtn")] : _vm._e()], 2)]), _vm.$scopedSlots['topBtn'] ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_vm._t("topBtn")], 2) : _vm._e()], 1)]], 2)], 1), _c('v-sheet', {
    staticClass: "pb-40 pb-lg-60 pt-160 pt-lg-180",
    class: {
      'dashboard-contents__full-height': _vm.fullHeight
    }
  }, [_c('v-container', {
    staticClass: "container--x-large"
  }, [_vm._t("contents")], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }